import {ChatMsgState} from "./chat-msg-types";


export interface ChatSettingState{
    themeInfo?: ThemeInfoObj
}


export const initialAppSetting: ChatSettingState = {
    themeInfo:undefined
}


export interface ThemeInfoObj {
    background: string;
    channelId: string;
    icon: string;
    headerColorStart:string;
    headerColorEnd:string;
    messageOne:string;
    messageTwo:string;



}